import React from 'react';
import Modal from '@components/common/Modal';
import { TouchableButton } from '../Touchable';
import { ReactComponent as ErrorIcon } from '@assets/images/errorPopUpIcon.svg';
import PropTypes from 'prop-types';

const FireBoardError = ({ closeErrorPopUp, isOpen, res, buttonLabel }) => {
  return (
    <Modal
      noBackground
      isOpen={isOpen}
      isModalCenter
      style={{
        width: '90%',
        maxWidth: '450px',
        margin: 'auto',
        backgroundColor: 'transparent',
        border: 'none',
      }}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="fs-16 fw-500"
        style={{
          fontFamily: 'Poppins',
          backgroundColor: 'var(--popup-body-bg)',
          borderRadius: '15px',
          color: 'var(--primary-text)',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          border: '1px solid var(--popup-body-border)'
        }}
      >
        <div className="d-flex d-flex align-items-center">
          <div className="me-3">
            <ErrorIcon alt="error" />
          </div>
          <div className="flex-grow-1 pl-3 lh_30">
            <p
              style={{ fontSize: '1rem', wordBreak: 'break-word' }}
              className="mb-0"
            >
              {res}
            </p>
          </div>
        </div>

        <div className="d-flex justify-content-center py-2">
          <TouchableButton
            style={{
              backgroundColor: 'var(--primary-btn-bg)',
              border: '1px solid var(--primary-btn-border)',
              color: 'var(--primary-btn-text)',
              fontWeight: 500,
              height: '54px',
            }}
            className="col-6 px-0 rounded fw-600"
            type="button"
            onClick={event => {
              event.preventDefault();
              closeErrorPopUp();
            }}
          >
            {buttonLabel || 'OK'}
          </TouchableButton>
        </div>
      </div>
    </Modal>
  );
};

FireBoardError.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  res: PropTypes.string.isRequired,
  closeErrorPopUp: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
};

export default FireBoardError;
